import React, { FC } from 'react';
import Image from 'next/image';
import styled, { css } from 'styled-components';
import { colors, shadows } from 'src/config/colors';
import { PartnerDTO } from 'src/common/models/partner';
import { media } from 'src/config/breakpoints';

const Partners = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;

  ${media.w.min.px768(css`
    grid-template-columns: repeat(3, 1fr);
  `)};
`;

const ImageContainer = styled.div`
  background: ${colors.white};
  box-shadow: ${shadows.drop1};
  border-radius: 0.375rem;
  position: relative;
  display: flex;
  align-items: center;
  padding: 2rem;
  height: auto;
`;

interface CourseBundlePartnersProps {
  partners: PartnerDTO[];
}

export const CourseBundlePartners: FC<CourseBundlePartnersProps> = ({ partners }) => (
  <Partners>
    {partners.map((partner) => (
      <ImageContainer key={partner.id}>
        <Image
          src={partner.partnerLogo.url}
          height={partner.partnerLogo.height}
          width={partner.partnerLogo.width}
        />
      </ImageContainer>
    ))}
  </Partners>
);
